class PersonalDetailsEdit extends FormValidation {
    constructor() {
        super();
        this.accountDrawer = document.querySelector('account-drawer');
        this.editPersonalDetailForm = this.querySelector('form');
        this.globalMessage = this.querySelector('.global-message');
        this.globalMessageCopy = this.querySelector('.global-message__copy');
        this.editPersonalDetailForm.addEventListener('submit', this.formSubmit.bind(this));
    }

    connectedCallback() {
        this.targetDrawer = this.editPersonalDetailForm.closest('.drawer__inner');
        this.globalMessage.addEventListener('click', (event) => this.handleGlobalMessageClick(event));
    }

    formSubmit(event) {
        event.preventDefault();
        if (!this.hasValidated) return;
        this.handleEditPersonalDetail();
    }

    handleEditPersonalDetail() {
        this.accountDrawer.toggleLoading();
        const phoneNumberInput = this.editPersonalDetailForm
            .querySelector("input[name='customer[phone_number]']")
            .value.trim();
        const phonePrefix = window.validation[Shopify.country].phone.prefix;
        const phone = phoneNumberInput ? phonePrefix + phoneNumberInput : '';
        const dobInputValue = this.editPersonalDetailForm.querySelector("input[name='dob']").value;
        const parts = dobInputValue.split('/');
        let dobFormatted = '';

        if (parts.length === 3) {
            dobFormatted = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }

        const regexPattern = /^(19|20)\d{2}-\d{2}-\d{2}$/;
        if (!regexPattern.test(dobFormatted)) {
            console.error('Date format is not right.');
            this.displayMessage(false, window.validationStrings.dateFormatError);
            this.accountDrawer.toggleLoading();
            return;
        }
        var formData = {
            email: this.editPersonalDetailForm.querySelector("input[name='customer[email]']").value,
            firstName: this.editPersonalDetailForm.querySelector("input[name='customer[first_name]']").value,
            lastName: this.editPersonalDetailForm.querySelector("input[name='customer[last_name]']").value,
            dob: dobFormatted,
            phone: phone,
        };

        fetch(getGlobalDomain(`/apps/bat-enhanced/customer/update`), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((jsonData) => {
                if (jsonData.ok) {
                    this.displayMessage(true, window.validationStrings.genericSuccess);
                } else {
                    console.error('Error:', jsonData.message);
                    this.displayMessage(false, jsonData.message);
                }
                this.accountDrawer.toggleLoading();
            })
            .catch((error) => {
                console.error('Error:', error);
                this.displayMessage(false, window.validationStrings.networkError);
                this.accountDrawer.toggleLoading();
            });
    }

    getErrorMessage = (message) => {
        message = this.decodeHtml(message);
        switch (message) {
            case 'phone-conflict':
                return window.accountSidebarStrings.errors.phoneConfict;
            default:
                return window.accountSidebarStrings.errors.default;
        }
    };

    displayMessage(isSuccess, message) {
        if (this.hasValidated) {
            this.globalMessage.classList.remove('global-message--success', 'global-message--error');
            this.globalMessage.classList.add(isSuccess ? 'global-message--success' : 'global-message--error');
            this.globalMessageCopy.innerHTML = isSuccess ? message : this.getErrorMessage(message);
            this.globalMessage.style.display = 'flex';
            this.globalMessage.style.opacity = 1;
        }
    }

    decodeHtml(html) {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = html;
        return textArea.value;
    }
}

customElements.define('personal-details-edit', PersonalDetailsEdit);
